/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const greenApiWebhookInteractiveButtonsResponseRequestSchema = z.object({
	stanzaId: z.string().min(1),
	selectedButtonId: z.string().min(1),
});
